import { RedButton, WhiteBlueButton } from 'components/Button'
import Column from 'components/Column'
import CurrencyLogo from 'components/CurrencyLogo'
import I18n from 'components/I18n'
import iconColor from 'components/iconColor'
import FasListAlt from 'components/Legacy/Icons/FasListAlt'
import FasTimes from 'components/Legacy/Icons/FasTimes'
import Row from 'components/Row'
import Text from 'components/Text'
import messages from 'lang'
import React, { useState } from 'react'
import { injectIntl, WrappedComponentProps as _I } from 'react-intl'
import { Field } from 'redux-form'
import styled from 'styled-components'
import { color, px, validator } from 'utils'

import Container from '../../Container'
import { StyledInput } from '../styles'
import { PropsType as _P } from '.'

const StyledRow = styled(Row)`
  border-top: 1px solid ${({ theme }) => theme.palette.grey600};
  padding: 1rem 0;
`
const SpacedRow = styled(Row)`
  margin-top: 1.5rem;
  justify-content: space-between;

  & > button {
    width: 47%;
  }
`
const ListContent = styled(Column)`
  margin-left: 0.8rem;
`
const RemoveAddressIcon = styled(FasTimes)`
  ${iconColor('grey400')};

  &:hover {
    cursor: pointer;
  }
`
const AddressName = styled(Text)`
  font-weight: 500;
  margin-bottom: 0.3rem;
`
const Address = styled(Text)`
  color: ${({ theme }) => theme.palette.grey400};
  font-weight: 500;
  font-size: 0.8rem;
`
const ScrollContainer = styled(Column)`
  height: 100%;
  min-height: 22rem;
  overflow-x: scroll;
`
const EmptyListWrapper = styled(Column)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 22rem;
  margin-top: -2rem;
`
const ListIcon = styled(FasListAlt)`
  ${iconColor('blue600')};
  margin-bottom: 2rem;
`
const Col = styled(Column)`
  flex: 1;
`
const CancelButton = styled(WhiteBlueButton)`
  border: 1px solid ${color('grey100')};
`
const TitleText = styled(Text)`
  margin-bottom: 0.5rem;
`

type PropsType = _P & _I

const AddressRenderer = (
  intl,
  showForm,
  formOpen,
  i,
  invalid,
  resetForm,
  setAddressToDelete,
  addr,
  twoFactorStatus
) => (
  <StyledRow justifyContent='space-between' key={addr.id}>
    <Col>
      <Row>
        <CurrencyLogo currency={addr.currency} size={px('1.5rem')} />
        <ListContent>
          <AddressName e2e='whitelistEntryName'>{addr.name}</AddressName>
          <Address e2e='whitelistEntryAddress'>
            {addr.address.substr(addr.address.length - 40, addr.address.length)}
          </Address>
        </ListContent>
      </Row>
      {formOpen && (
        <>
          <SpacedRow>
            <Field
              component={StyledInput}
              data-lpignore='true'
              e2e='2faCode'
              label={intl.formatMessage(messages.label_code)}
              name='code'
              placeholder={intl.formatMessage(messages.title_verify_2fa)}
              type={twoFactorStatus!.includes('WALLET_YUBIKEY') ? 'password' : 'text'}
              validate={[validator.required]}
            />
          </SpacedRow>
          <SpacedRow style={{ flexFlow: 'row-reverse' }}>
            <RedButton disabled={invalid} e2e='confirmmDeleteWhitelistAddress' type='submit'>
              {intl.formatMessage(messages.delete_whitelist)}
            </RedButton>
            <CancelButton e2e='cancelDeleteWhitelistAddressButton' onClick={() => showForm(null)}>
              {intl.formatMessage(messages.button_cancel)}
            </CancelButton>
          </SpacedRow>
        </>
      )}
    </Col>
    <RemoveAddressIcon
      data-e2e='deleteWhitelistAddress'
      onClick={() => {
        resetForm()
        if (formOpen) {
          showForm(null)
        } else {
          showForm(i)
        }
        setAddressToDelete(addr.id)
      }}
      size='1rem'
    />
  </StyledRow>
)

const ListAddresses = ({
  addresses,
  intl,
  invalid,
  resetForm,
  setAddressToDelete,
  twoFactorStatus
}: PropsType) => {
  const [removalFormIndex, showRemovalForm] = useState(null)
  return (
    <Container>
      <Column>
        {addresses.length > 0 ? (
          <ScrollContainer>
            <TitleText color='white' size='sm' weight={500}>
              <I18n data={messages.whitelisting_manage_sub_title} />
            </TitleText>
            {addresses.map((addr, i) => {
              return AddressRenderer(
                intl,
                showRemovalForm,
                removalFormIndex === i,
                i,
                invalid,
                resetForm,
                setAddressToDelete,
                addr,
                twoFactorStatus
              )
            })}
          </ScrollContainer>
        ) : (
          <EmptyListWrapper>
            <ListIcon size='50px' />
            <Text color='grey600' size='lg' weight={500}>
              <I18n data={messages.whitelisted_addresses_none} />
            </Text>
          </EmptyListWrapper>
        )}
      </Column>
    </Container>
  )
}

export default injectIntl(ListAddresses)
